import { Link } from 'react-router-dom'
import styles from './MobileAppManager.module.css'
import { useNavigate, useLocation } from 'react-router-dom'


const MobileAppManager = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const exhibitorAccount = location.state    

    return (
        <div id={styles.eventConfigurePage}>
            <h1>Mobile App Management</h1><br />
            <h2>Control configuration setup for {exhibitorAccount.firstName} {exhibitorAccount.lastName} - {exhibitorAccount.organization} ({exhibitorAccount.refNumber}).</h2><br />
            <div id={styles.eventConfigureContainer}>
                <Link to={`/QualifierManager`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Manage qualifiers for LR App.">
                    <h3>Manage LR App Qualifiers</h3>
                </Link>
                <Link to={`/ExhibitorLicenseManager`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Manage exhibitor licenses for LR App.">
                    <h3>Manage LR App Licenses</h3>
                </Link>
                <Link to={`/ExhibitorLeads`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="View/download leads for LR App.">
                    <h3>View/Download LR App Leads</h3>
                </Link>
                <Link to={`/ExhibitorPasscodes`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="View/download passcodes for LR App.">
                    <h3>View/Download LR Passcodes</h3>
                </Link>
                <Link to={`/elmah`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="Manage licenses for SAS App.">
                    <h3>Manage SAS App Licenses</h3>
                </Link>
                <Link to={`/elmah`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="View/download leads for SAS App.">
                    <h3>View/Download SAS App Leads</h3>
                </Link>
                <Link to={`/elmah`} className={styles.eventLinks}
                    state={exhibitorAccount}
                    title="View/download passcodes for SAS App.">
                    <h3>View/Download SAS Passcodes</h3>
                </Link>
            </div>

            <button id={styles.backButton} onClick={() => navigate(-1)}> Back </button>
        </div>
    );
}

export default MobileAppManager;